import { V3_SMALL } from "./v3app";

export function PlanSaveStatus({ writer }) {
  if (writer.phase === "idle") return null;
  const text = writer.phase === "saving" ? "Speicherstand wird geprüft …"
    : writer.phase === "confirmed" ? "Gespeichert und erneut geladen."
      : writer.phase === "stored" ? "Die Angaben sind gespeichert. Der Abschluss der Anfrage ist noch nicht bestätigt."
        : writer.reason;
  return <div role={writer.phase === "rejected" ? "alert" : "status"} aria-live="polite" data-testid="plan-save-status" className="mt-[12px] space-y-2 break-words text-[14px] text-v3-ink">
    <p>{text}</p>
    {(writer.phase === "unclear" || writer.phase === "stored") && <button type="button" onClick={writer.check} className={V3_SMALL} data-testid="plan-save-check">Speicherstand prüfen</button>}
  </div>;
}
